<!--  -->
<template>
  <div>
    <div class="header">
        <div class="box">
            <div class="L"><a onClick="javascript:history.back(-1)" class="goback"><img src="/static/images_m/goback.png" /></a></div>
            <div class="C"><p>我的课程</p></div>
        </div>
    </div>  
    <div class="clear"></div>
    <div class="hbox"></div>
    <div class="courseBox" style="padding:0">
    <ul class="ul_3">
        <li v-for="(course,index) in courses" :key="index"  @click="$router.push(`/courview/info/${course._id}`)">
            <div class="L"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`"></div>
            <div class="R">
                <div class="tit">{{course.title}}</div>
                <div class="sub">
                    讲师：{{course.author}}
                </div>
                <div class="xx"><span>
                    <el-rate
                        v-if="course.stars"
                        disabled
                        show-score
                        text-color="#ff9900"
                        :score-template="parseFloat(course.stars).toFixed(1)">
                        </el-rate>
                        <span v-else>暂无评分</span>
                    </span><p>{{course.isBuy==1? '立即学习':course.isBuy==0?'报名学习':course.isBuy==3?'未开始':'已到期'}}</p></div>
            </div>
        </li>
    </ul>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      courses: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") { 
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
    this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt&type[in]="+ this.$root.hasCourse)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
          this.intTotal = res.data.total;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
        if(this.$root.hasCourse.length==0) {
            return
        }
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=-createdAt";
      }
      if (this.searchPrice == "0") {
        searchConditions += "&price=0";
      } else {
        searchConditions += "&price[ne]=0";
      }
      this.$axios
        .get(
          `/api/courses/visitor?page=${
            this.intCurrent
          }&limit=6${searchConditions}&_id[in]=${this.$root.hasCourse.join(",")}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.courses = res.data.data;
            this.toTop();
          }
        });
    },
  },
};
</script>
<style  lang="scss" scoped>
  @import "@/assets/css/style_Phone.scss";
</style>
